<template>
    <h3 v-html="$t('TEXT_CONTACT_US_CONFIRM_HEADER')" ref="formRef"></h3>

    <div>
        <div class="p-contact__form p-contact__form--confirm">
            <dl v-if="!userStore.isOverseasUser" class="category">
                <dt>お名前（姓）<span>＊</span></dt>
                <dd>
                    <p>{{ contactUsStore.params.last_name }}</p>
                </dd>
            </dl>
            <dl class="category">
                <dt>お名前（名）<span>＊</span></dt>
                <dd>
                    <p>{{ contactUsStore.params.first_name }}</p>
                </dd>
            </dl>
            <dl class="category">
                <dt>お電話番号<span>＊</span></dt>
                <dd>
                    <p>{{ contactUsStore.params.phone_number }}</p>
                </dd>
            </dl>
            <dl class="category">
                <dt>Emailアドレス<span>＊</span></dt>
                <dd>
                    <p>{{ contactUsStore.params.email }}</p>
                </dd>
            </dl>
            <dl class="category">
                <dt>お問い合わせ区分<span>＊</span></dt>
                <dd>
                    <p>{{ contactUsStore.selectedCategory.name }}</p>
                </dd>
            </dl>
            <dl class="category">
                <dt>利用サービス</dt>
                <dd>
                    <p>{{ (contactUsStore.params.service_name != null && contactUsStore.params.service_name != "") ? contactUsStore.params.service_name : $t('LABEL_NOT_SELECTED') }}</p>
                </dd>
            </dl>
            <dl v-for="custom_field in contactUsStore.customFields" class="category">
                <dt>{{ locale == "ja" ? custom_field.label_ja : custom_field.label_en  }}</dt>
                <dd>
                    <p>{{ custom_field.content }}</p>
                </dd>
            </dl>
            <dl class="category">
                <dt>決済ID</dt>
                <dd>
                    <p>{{ contactUsStore.params.payment_id }}</p>
                </dd>
            </dl>
            <dl class="details">
                <dt>{{ $t("LABEL_CONTACT_US_CONTENT") }}<span>＊</span></dt>
                <dd>
                    <p>{{ contactUsStore.params.content }}</p>
                </dd>
            </dl>
        </div>

        <div class="p-contact__btn p-contact__btn--confirm">
            <div class="c-btn c-btn--contact-submit"><input id="btn-send" v-on:click="confirm" type="button" :value="$t('LABEL_SEND_BUTTON')"></div>
            <div class="c-btn c-btn--contact-cancel"><button v-on:click="cancel">{{ $t("LABEL_CANCEL") }}</button></div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useContactUsStore } from "@/stores/contactUsStore";
import { useUserStore } from "@/stores/userStore";
import { useI18n } from "vue-i18n";

const formRef = ref();
const contactUsStore = useContactUsStore();
const userStore = useUserStore();
const { locale } = useI18n();

onMounted(async () => {
    formRef.value.scrollIntoView({ behavior: "smooth", block: "center" });
});

async function confirm() {
    await contactUsStore.createContactUs();
    contactUsStore.step = "complete";
}

function cancel() {
    contactUsStore.step = "input";
}
</script>